import { FormattedMessage } from "react-intl";

import SBEditable from "../../../components/sbEditable/sbEditable"
import ListingHeader from "../../../components/listingHeader/listingHeader"
import ArticleListingCard from "../../../components/articleListingCard/articleListingCard";

import {useStoryblokLatestNewsFeaturedWidget} from "../../../hooks/useStoryblokLatestNewsFeaturedWidget";

import styles from "./latestNewsFeaturedWidget.module.scss";
import RouterLink from "../../../components/link/RouterLink";


/// >> Blok:latestnewsasidewidget
// headline:text
function LatestNewsFeaturedWidget({ blok }) {
  const [articleList, isLoading] = useStoryblokLatestNewsFeaturedWidget();

  if (!isLoading && articleList.length === 0) {
    return null;
  }

  return (
    <SBEditable blok={blok} withClass={`${styles.root} ${blok.margin_top ? styles.marginTopDefault : ""} ${blok.margin_bottom ? styles.marginBottomDefault : ""}`}>
      <div className={styles.headerWrapper}>
        <ListingHeader withClass={styles.listingHeader}>
          <h2><FormattedMessage id="component.latest_news_featured_widget.headline" /></h2>
        </ListingHeader>
      </div>
      <div className={styles.contentWrapper}>
        <ul className={styles.wrapper}>
          {isLoading ? <div className="loader centered" /> : null}
          {articleList.map((a,idx) => {
            return (
              <li key={a.uuid}>
                <ArticleListingCard
                  key={a._uid}
                  layout={idx < 3 ? "featured_latest_news" : "noImage_latest_news"}
                  slug={a.slug}
                  thumbnail={a.content.thumbnail}
                  authors={a.content.authors}
                  title={a.content.headline}
                  summary={a.content.lead}
                  date={a.content.created_at}
                  article_category={a.content.category}
                  article_type={a.content.article_type}
                  comment_count={5}
                  enable_comments={a.content.has_comments}
                  enable_social_sharing={a.content.has_social_sharing}
                  use_legacy_thumbnail_background={a.content.legacy_thumbnail_background}
                />
              </li>
            )
          })}
        </ul>
        <div className={styles.asideCTA}>
          <RouterLink
              to="/latest"
              className="btn btn-scooter-outline"
          >
            <FormattedMessage id="component.latest_news_featured_widget.all_button" />
          </RouterLink>
        </div>
      </div>
    </SBEditable>
  )
}

export default LatestNewsFeaturedWidget
